'use strict'

var tester = /["]/

const validateDisplayName = function(displayname)
{
  if (!displayname.trim())
    return false
		
  if (displayname.length>50)
    return false

  if (displayname.length<1)
    return false

  var invalid = tester.test(displayname)
  if (invalid)
    return false

  return true
}

export default validateDisplayName


// WEBPACK FOOTER //
// ./src/core/components/utilities/ValidateDisplayName.js